/*
 * @author Svilen Gospodinov <svilen.gospodinov@gmail.com>
 * @homepage https://github.com/svileng/ng-simplePagination
 */
angular.module('simplePagination', []).factory('Pagination', function() {

  var pagination = {};

  pagination.getNew = function(perPage, rangeNumber) {

    perPage = perPage === undefined ? 5 : perPage;

    var paginator = {
      numPages: 1,
      perPage: perPage,
      page: 0,
      rangeNumber: rangeNumber || 1
    };

    paginator.prevPage = function() {
      if (paginator.page > 0) {
        paginator.page -= 1;
      }
    };

    paginator.nextPage = function() {
      if (paginator.page < paginator.numPages - 1) {
        paginator.page += 1;
      }
    };

    paginator.toPageId = function(id) {
      if (id >= 0 && id <= paginator.numPages - 1) {
        paginator.page = id;
      }
    };

    paginator.getNumbers = function(){
      var numbers = [];
      for(var i = paginator.page;i < (paginator.page + paginator.rangeNumber); i++){
        numbers.push(i);
      }

      return numbers;
    }

    return paginator;
  };

  return pagination;
}).filter('startFrom', function() {
  return function(input, start) {
    if (input === undefined) {
      return input;
    } else {
      return input.slice(+start);
    }
  };
}).filter('range', function() {
  return function(input, start, end) {
    end = parseInt(end);
    for (var i = start; i < end; i++) {
      input.push(i);
    }
    return input;
  };
});
